
export class CustomConstants {

    // Version
    public static ADMIN_SOFTWARE_VERSION: string = "v1.3.6";

    // Admin
    public static ADMIN_SOFTWARE_NAME: string = "JAS Platform";
    public static ADMIN_SOFTWARE_ENDPOINT: string = "https://admin.app.jasmonitoring.com";
    public static MONITORING_SOFTWARE_URL: string = "https://app.jasmonitoring.com";

    // Backend
    public static API_ENDPOINT: string = "https://us-central1-jas-tier-3-platform.cloudfunctions.net/v2";
    public static SERVER_UIDS: string[] = [
        "jas-data-server",
        "jas-schedule-server",
        "jas-billing-server",
        "jot-server"
    ];

    // (Automatic billing)
    public static STRIPE_OEM_CONNECT_ID: string = "acct_1RfnP4K3KXtvgA3n";

    // Return the stripe fee amount for a given price ID (100 = $1)
    public static getJASFeeForPriceID(priceID: string | null): number {
        // Default to none
        return 0;
    }

}
